// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6b3e6f15","457":"64f7c483"}[chunkId] + ".chunk.js";
};